<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div
      class="content-section"
    >
      <div
        v-if="loading"
      >
        <v-skeleton-loader
          :loading="loading"
          type="avatar, heading, sentences, sentences, sentences, sentences"
          elevation="0"
        >
          <v-list-item
            lines="two"
            subtitle="Subtitle"
            title="Title"
            rounded
          />
        </v-skeleton-loader>
      </div>
      <div v-else>
        <br>
        <br>
        <div class="d-flex align-center flex-column">
          <v-icon
            size="80"
            color="#37474F"
          >
            mdi-account-hard-hat
          </v-icon>
          <h2>
            {{ appUserDetails.first_name }} {{ appUserDetails.last_name }}
          </h2>
        </div>
        <br>
        <div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-key-variant
              </v-icon>Role
            </p>
            <p class="value-text-style pl-7">
              {{ appUserDetails.app_user_role }}
            </p>
          </div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-phone
              </v-icon>Phone
            </p>
            <p class="value-text-style pl-7">
              {{ appUserDetails.phone_number }}
            </p>
          </div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-email
              </v-icon>Email
            </p>
            <p
              v-if="appUserDetails.email"
              class="value-text-email pl-7"
            >
              {{ appUserDetails.email }}
            </p>
            <p
              v-else
              class="value-text-style pl-7"
            >
              N/A
            </p>
          </div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-swap-horizontal-bold
              </v-icon>Check-in Types
            </p>
            <p class="value-text-style pl-7">
              {{ appUserDetails.types | arrangePretty }}
            </p>
          </div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-clock
              </v-icon>Allowed Work Time
            </p>
            <p class="value-text-style pl-7">
              {{ appUserDetails.work_hours }} Hrs
            </p>
          </div>
          <div class="box">
            <p class="title-text-style">
              <v-icon
                size="18"
                class="pr-2"
                color="#37474F"
              >
                mdi-shield-alert
              </v-icon>Emergency Contacts
            </p>
            <p
              v-if="Object.keys(appUserDetails).length > 0 && appUserDetails.emergency_contact.length === 0"
              class="value-text-style pl-7"
            >
              N/A
            </p>
            <p
              v-else
              class="value-text-style pl-7"
            >
              <span
                v-for="(item, index) in appUserDetails.emergency_contact"
                :key="index"
              >
                {{ item.name }} : {{ item.phone_number }}<br>
              </span>
            </p>
          </div>
        </div>
      </div>

      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
    </div>
  </v-dialog>
</template>
  <script>
  export default {
    name: 'AppUserDetails',
    components: {
    },
    filters: {
      arrangePretty (val) {
  if (Array.isArray(val)) {
    return val.map(type => type === 'staff' ? 'Site Manager' : type).join(', ');
  }
  return val;
},
    },
    props: {
      orgExternalId: {
        type: String,
        default: null,
      },
      appuserId: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        showModal: true,
        loading: false,
      };
    },
    computed: {
      appUserDetails () {
        return this.$store.getters['appusers/getAppUserDetails'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.getAppUserDetails();
    },
    methods: {
     async getAppUserDetails () {
      this.loading = true;
        await this.$store.dispatch('appusers/fetchAppUserDetails', {
        externalId: this.orgExternalId,
        id: this.appuserId,
      });
      this.loading = false;
      },
    },
  };
  </script>
  <style scoped>
.btns {
  position: absolute;
  top: 0;
  right: 0;
  gap: 10px;
  display: flex;
}
.title-text-style{
    font-size: 12px!important;
    margin-bottom: 10px!important;
}
.box{
    border-bottom: 1px solid #37474f1a;
    padding-top: 10px;
}
.v-skeleton-loader--is-loading {
  margin-top: 20px;
}

.v-skeleton-loader>>>.v-skeleton-loader__table-heading {
  background: transparent !important;
}

.v-skeleton-loader>>>.v-skeleton-loader__avatar {
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
}

.v-skeleton-loader>>>.v-skeleton-loader__heading{
  left: 50%;
  transform: translateX(-50%);
  margin-top: 15px;
}
.v-skeleton-loader >>>  .v-skeleton-loader__article {
  background: transparent!important;
}
.v-skeleton-loader >>> .v-skeleton-loader__avatar, .v-skeleton-loader>>> .v-skeleton-loader__text, .v-skeleton-loader>>> .v-skeleton-loader__heading{
  background-color: #eceff1!important;
}
.v-skeleton-loader>>> .v-skeleton-loader__text{
margin-top: 20px;
}
.value-text-email {
  color: black;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}
</style>
